import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  checkBoxContainerStyle: {
    borderWidth: 0,
    padding: 0,
  },
});
